import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  isShow: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false,
  isShow: false
}

export const userMessage = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_MESSAGE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_USER_MESSAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_USER_MESSAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data,
        isShow: true
      }
    case actionTypes.CLOSE_USER_MESSAGE_MODAL:
      return {
        ...state,
        isShow: false
      }
    case actionTypes.OPEN_USER_MESSAGE_MODAL:
      return {
        ...state,
        isShow: true
      }
    default:
      return state;
  }
}
